import { render, staticRenderFns } from "./LikeIcon.vue?vue&type=template&id=5efca354&"
import script from "./LikeIcon.vue?vue&type=script&lang=js&"
export * from "./LikeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports